<template>
  <div class="currencyBar">
    <div :class="isSelected('pound')" @click="currencySelect('pound')">&pound;</div>
    <div :class="isSelected('dollar')" class="symbol" @click="currencySelect('dollar')">&dollar;</div>
    <div :class="isSelected('euro')" class="symbol" @click="currencySelect('euro')">&euro;</div>
  </div>
</template>

<style lang="scss" scoped>
.currencyBar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.symbol {
  font-size: 20px;
  font-weight:bold;
  border: 2px $white solid;
  border-radius: 30px;
  width: 50px;
  height: 25px;
  text-align: center;
  color: $white;
  margin: 0px 5px 0px 5px;
  padding-top:0px;
  transition:all 0.5s ease-in-out;

  &:hover {
    border: 2px $blue solid;
  }
}

.active {
  @extend .symbol;
  color: $blue;
  background: $white;
  border: 2px $white solid;
  &:hover {
    border: 2px $white solid;
  }
}
</style>

<script>
export default {
    methods:{
        currencySelect(currency){
            this.$store.commit('setCurrency',{currency: currency});
        },
        isSelected(symbol){
            const currentlySelected = this.$store.getters.getCurrency;
            if (symbol == currentlySelected){
                return "active"
            } else {
                return "symbol"
            }
        }
    }
}
</script>